import React, { memo } from 'react';
import styled from 'styled-components';
import { translate } from '../../../common/translation/translate';
import { smallMediaQuery } from '../../../common/utilities/sizeHelpers';
import { BreakingNewsCloseIcon } from './breakingNewsCloseIcon';

export const BreakingNewsButtons = memo(() => {
    return (
        <Container>
            <ContentWrap>
                <BreakingNewsTextContainer>
                    <BreakingNewsText>
                        {translate('breakingNews')}
                    </BreakingNewsText>
                </BreakingNewsTextContainer>
                <BreakingNewsCloseIcon />
            </ContentWrap>
        </Container>
    );
});

const Container = styled.div`
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    width: 100%;
    height: 40px;
    position: absolute;
    @media ${smallMediaQuery} {
        height: 25px;
        margin-top: 13px;
    }
`;

const ContentWrap = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    margin: 0 auto;
    max-width: calc(1218px + 8%);
    padding: 0 4%;
`;

const BreakingNewsTextContainer = styled.div`
    display: flex;
    width: calc(100% - 35px);
    height: 100%;
`;

const BreakingNewsText = styled.div`
    width: 169px;
    height: 100%;
    background-color: #d84544;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 18px;
    color: #FFF;
    line-height: 23px;
    justify-content: center;
    align-items: center;
    padding: 8px 0;
    border-radius: 2px;
    display: flex;

    @media ${smallMediaQuery} {
        width: 104px;
        font-size: 12px;
        padding: 0;
    }
`;